var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPendingAlerts)?_c('Row',{staticClass:"inbox-pending-alerts flex-centerize"},[_c('h5',{staticClass:"inbox-pending-alerts-text"},[_vm._v(_vm._s(_vm.numberOfRelevantAlerts))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }